import type { ComponentProps, JSX } from "react";
import { memo } from "react";

import styles from "./styles.module.scss";

export const PaginationBase = memo(function PaginationBase({
  ...props
}: ComponentProps<"nav">): JSX.Element {
  return (
    <nav
      role={"navigation"}
      aria-label={"pagination"}
      className={styles.paginationContainer}
      {...props}
    />
  );
});
